import {UrlLink} from '../../../applink/UrlLink';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {CheckBoxV2} from '../CheckBoxV2/CheckBoxV2';
import {CheckListItemProps} from './CheckListItemProps.interface';

export function CheckListItem({
  showCheckBox = true,
  checked = false,
  disabled = false,
  label,
  isTitle,
  url,
  onChangeChecked,
  isWebView,
  onClickUrl,
  className,
  ...props
}: CheckListItemProps) {
  return (
    <div
      className={twMerge(
        'flex items-center self-stretch py-12pxr gap-8pxr',
        className
      )}
      {...props}
    >
      <label
        className={twMerge(
          'flex flex-1 items-center gap-8pxr',
          showCheckBox && 'cursor-pointer'
        )}
      >
        {showCheckBox && (
          <CheckBoxV2
            checked={checked}
            disabled={disabled}
            onChange={onChangeChecked}
            className="h-16pxr w-16pxr"
          />
        )}
        <Text
          className={twMerge(
            'flex-1 text-theme-solid-100',
            isTitle ? 'font-medium1-bold' : 'font-small1'
          )}
        >
          {label}
        </Text>
      </label>
      {url && (
        <UrlLink
          shouldOpenNewWindow={!isWebView}
          url={url}
          windowTitle={label}
          linkClassName="flex"
          {...(onClickUrl && {
            preventEvent: true,
            onClick: () => onClickUrl(url),
          })}
        >
          <Icon type={IconType.ButtonArrowRight} className="ml-auto" />
        </UrlLink>
      )}
    </div>
  );
}
